<template>
<div class="player">
    <div :class="darkmodeBoolean ? 'darkmode' : 'lightmode'">
        <div class="top-bar">
            <!-- <i class="fa fa-bars" style="position: absolute; left: 10px; font-size: 28px;"  @click="showStationsToggle()" id="showStationsToggle"></i> -->
            <img :src="darkmodeBoolean ? '/img/logo_white.svg' : '/img/logo.svg'" alt="Logo" style ="height: 45px;" />
            <button id="install" style="display:none; position: absolute; left: 60px; background-color: #ed2c63; padding: 5px 7px 5px 7px; border-radius: 2px; color:#FFFFFF;">Install</button>
            <i v-if="false" class="fas fa-gift" id="showGiftsToggle" style="position: absolute; right: 55px; font-size: 28px; color: #FF0000;"  @click="showGiftsToggle()"></i>
            <i class="fas fa-gear" id="showSettingsToggle" style="position: absolute; right: 10px; font-size: 28px;"  @click="showSettingsToggle()"></i>
        </div>

        <div class="overlay-background"></div>

        <div class="flex" style="position: relative; align-items: center; align-content: center; justify-content: center; height: calc(100vh - 140px); padding-top: 50px;">
            <div id="canvasParent" style="position: absolute; max-width: 960px; z-index: 1; display: flex; justify-content: center; width: 100%; margin-top: -90px;">
                <audio ref="foo" crossorigin="anonymous" style="z-index:5;" />
                <av-circle
                    v-if="animationBoolean"
                    ref-link="foo"
                    :outline-width="0"
                    :progress="true"
                    :progress-width="3"
                    :centeredSlides="true"
                    :centered-slides="true"
                    progress-color="#ed2c63"
                    :outline-meter-space="5"
                    :bar-length="30"
                    :bar-width="2"
                    :bar-color="barColor"
                    :canv-width="canvasWidth"
                    :canv-height="canvasHeight"
                    >
                </av-circle>            
            </div>
            
            <div class="flex flex-col" style="position: relative; align-content: center; align-items: center; justify-content: center;">
                <div class="circle-image">
                    <img :src="stations[0].image_url" alt="Station image"/>
                    
                    <div class="circle-label">
                        {{ stations[0].is_stream ? "V ŽIVO" : "ODDAJA" }}
                    </div>

                    <div class="circle-background"></div>
                </div>
                <div class="song-info" :class="stations.length == 1 ? '' : 'song-info-multiple'" style="padding-top: 30px;">
                    <div v-if="stations[0] && stations[0]['songs'] && stations[0]['songs'][0]" class="current-artist">
                        {{ stations[0].title }}
                    </div>

                    <div v-if="stations[0] && stations[0]['songs'] && stations[0]['songs'][0] && !stations[0]['songs'][0].api_down" class="current-title-group">
                        <div v-if="!stations[0].is_stream" class="current-title current-title-stream">{{ stations[0]['songs'][0].title }}</div>
                        <div v-else class="current-title" :class="animationBoolean ? 'marquee marquee--fit-content' : ''">
                            <ul :class="animationBoolean ? 'marquee__content' : ''">
                                <li :class="animationBoolean ? '' : 'li-no-animation'">{{ stations[0]['songs'][0].author + " - " + stations[0]['songs'][0].title }}</li>
                            </ul>
                            <ul v-if="animationBoolean" :class="animationBoolean ? 'marquee__content' : ''">
                                <li :class="animationBoolean ? '' : 'li-no-animation'">{{ stations[0]['songs'][0].author + " - " + stations[0]['songs'][0].title }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
      <!--
        <swiper style="height: 100vh; z-index: 2;"
                class="mySwiper"
                direction="vertical"
                :modules="swiperModules"
                :slides-per-view="slidesPerView"
                :mousewheel="true"
                :allowTouchMove="true"
                @slide-change="slideChange"
                :lazy="{loadPrevNext: true, loadPrevNextAmount: 1}"
                id="swiper"
                ref="swiper"
                >
            <swiper-slide v-for="(station, index) in stations" :key="index" class="swiper-slide">
                <div class="circle-image">
                    <img :data-src="stations[index].image_url" alt="Station image" class="swiper-lazy"/>
                    <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>	
                    
                    <div class="circle-label">
                        {{ station.is_stream ? "V ŽIVO" : "ODDAJA" }}
                    </div>

                    <div class="circle-background"></div>
                </div>
                <div class="song-info" :class="stations.length == 1 ? 'song-info-single' : 'song-info-multiple'">
                    <div v-if="station && station['songs'] && station['songs'][0]" class="current-artist">
                        {{ station.title }}
                    </div>

                    <div v-if="station && station['songs'] && station['songs'][0] && !station['songs'][0].api_down" class="current-title-group">
                        <div v-if="!station.is_stream" class="current-title current-title-stream">{{ station['songs'][0].title }}</div>
                        <div v-else class="current-title" :class="animationBoolean ? 'marquee marquee--fit-content' : ''">
                            <ul :class="animationBoolean ? 'marquee__content' : ''">
                                <li :class="animationBoolean ? '' : 'li-no-animation'">{{ station['songs'][0].author + " - " + station['songs'][0].title }}</li>
                            </ul>
                            <ul v-if="animationBoolean" :class="animationBoolean ? 'marquee__content' : ''">
                                <li :class="animationBoolean ? '' : 'li-no-animation'">{{ station['songs'][0].author + " - " + station['songs'][0].title }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </swiper-slide>            
        </swiper>
        -->

        <div class="flex flex-col bottom-bar">
            <div class="flex flex-row bottom-bar-icons" style="height: 100%; align-items: center; align-content: center; justify-content: space-around; font-size: 48px; color: #161a1b; margin-top: -5px;">
                <a href="tel:015880131" style="display: flex;" aria-label="Call the radio's telephone number">
                    <i class="fas fa-phone fa-flip-horizontal" :class="is_iOS ? 'ios' : ''"></i>
                </a>

                <!--
                <span class="fontawesome-circle">
                    <i class="fas fa-backward" @click="seekBack()" style="margin-right: 4px;"></i>
                </span>
                -->

                <i :class="[(!isPlaying ? 'fas fa-play-circle' : 'fas fa-pause-circle'), (is_iOS ? 'ios' : '')]" class="play-pause" style="font-size: 68px;" @click="togglePlay()"></i>

                <!--
                <span class="fontawesome-circle">
                    <i class="fas fa-forward" @click="seekForward()" style="margin-left: 4px;"></i>
                </span>
                -->

                <a href="https://www.tiktok.com/@bestfmslo" target="_blank" style="display: flex;" aria-label="Open Tik Tok web page">
                    <i class="fas fa-brands fa-tiktok" :class="is_iOS ? 'ios' : ''"></i>
                </a>
                
                <!--
                <Datepicker v-if="currentStation" v-model="showDate" @update:modelValue="changeDate" type="date" position="right" :disabled="currentStation.is_stream ? true : false" :enableTimePicker="false" autoApply :highlight="highlightedDates" :disabledDates="disabledDates" :minDate='new Date("2022-08-01")' :maxDate='new Date()' noToday style="display: flex;" aria-hidden="true">
                    <template #trigger style="display: flex;">
                        <i class="fas fa-calendar-days" :class="[(currentStation.is_stream ? 'disabled' : ''), (is_iOS ? 'ios' : '')]" aria-hidden="true"></i>
                    </template>
                </Datepicker>
                -->
            </div>

            <div class="flex flex-row" id="bottomBarSong" style="width: 100%;height: 100%; border-top: 1px solid; border-color:#d4d4d4; align-items: center; align-content: center; padding-left: 15px; padding-right: 15px;">
                <div class="square-image-small" style="background-color: #414a4c;">
                    <img :src="currentStation.image_url_small" alt="Station image" />
                </div>
                
                <div v-if="currentStation && currentStation['songs']" class="bottom-bar-song-info" style="padding-left: 15px; width: calc(100% - 75px);">
                    <div class="flex flex-col" style="width: 100%; height: 100%; align-items: baseline; align-content: center; text-align: left; font-size: 10px;">
                        {{ currentStation['songs'][0].author }}
                    </div>

                    <div v-if="!currentStation['songs'][0].api_down" class="flex flex-col" style="width: 100%;height: 100%; align-items: baseline; align-content: center; text-align: left; font-size: 14px; font-weight: 700;">
                        {{ currentStation['songs'][0].title }}
                    </div>
                </div>

                <div v-if="stations && stations[currentStationIndex] && stations[currentStationIndex].api_url && currentStation && currentStation['songs']  && !currentStation['songs'][0].api_down" @click="showHistoryToggle()" id="showHistoryToggle" style="margin-left: auto; display: flex; align-items: center; position: absolute; right: 0; padding-left: 30px; height: 72px; padding-right: 15px;">
                    <i class="fa fa-solid fa-up-down" id="showHistoryToggleIcon" style="font-size: 24px;"></i>
                </div>
            </div>
        </div>


        <div v-if="true" ref="showHistoryRef" id="showHistory" class="showHistory" style="z-index: 5; position: fixed; max-width: 958px; bottom:0; width: 100%;">
            <div @click="showHistoryToggle()" style="position: sticky; top: 0; right: 0; font-size: 28px;">
                <i class="fas fa-window-close" id="showHistoryClose" style="position: absolute; top: 6px; right: 7px; font-size: 28px;"></i>
            </div>
            <div v-if="currentStation && currentStation['songs'] && !currentStation['songs'][0].api_down" v-for="(station, index) in currentStation['songs']" :key="index">
                <div v-if="station" class="flex flex-row song-history" style="width: 100%; border-bottom:1px solid; align-items: center; align-content: center; padding: 15px;">
                    <div class="circle-image-small" style="background-color: #414a4c;">
                        <img :src="currentStation.image_url_small" alt="Station image" />
                    </div>
                    <div style="padding-left: 15px;">
                        <div class="flex flex-col" style="width: 100%;height: 100%; align-items: baseline; align-content: center; text-align: left; font-size: 10px; line-height: 1.1; padding-bottom: 2px;">
                            {{ station.author }}
                        </div>

                        <div v-if="!currentStation['songs'][0].api_down" class="flex flex-col" style="width: 100%;height: 100%; align-items: baseline; align-content: center; text-align: left; font-size: 14px; font-weight: 700; line-height: 1.1;">
                            {{ station.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="showSettings" class="showSettings" style="z-index: 5; position: fixed; max-width: 958px; top:0; height: 0px; width: 100%;">
            <i @click="showSettingsToggle()" class="fas fa-window-close" id="showSettingsClose" style="position: absolute; top: 7px; right: 7px; font-size: 28px;"></i>
            <div class="flex flex-row" style="width: 100%; border-bottom:1px solid; align-items: center; align-content: center; padding: 15px 30px; margin-top: 45px; border-top: 1px solid;">
                <div class="flex flex-col" style="width: 100%; height: 100%; align-items: baseline; align-content: center; justify-content: center; text-align: left; font-size: 20px; font-weight: 700; line-height: 1.1;">
                    Toggle darkmode
                    <label class="switch" style="position: absolute; right: 15px;">
                        <input @click="toggleDarkMode()" v-model="darkmode" :disabled="daytimeMode" type="checkbox">
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>
            <div v-if="is_iOS == false" class="flex flex-row" style="width: 100%; border-bottom:1px solid; align-items: center; align-content: center; padding: 15px 30px;">
                <div class="flex flex-col" style="width: 100%; height: 100%; align-items: baseline; align-content: center; justify-content: center; text-align: left; font-size: 20px; font-weight: 700; line-height: 1.1;">
                    Toggle animations
                    <label class="switch" style="position: absolute; right: 15px;">
                        <input @click="toggleAnimation()" v-model="animationBoolean" type="checkbox">
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>
            <div class="flex flex-col" style="width: 100%; border-bottom:1px solid; align-items: center; align-content: center; padding: 15px 30px;">
                <div class="flex flex-col" style="width: 100%; height: 100%; padding-right: 30px; align-items: baseline; align-content: center; justify-content: center; text-align: left; font-size: 20px; font-weight: 700; line-height: 1.1;">
                    Auto set day/night theme
                    <label class="switch" style="position: absolute; right: 15px;">
                        <input @click="toggleDaytimeMode()" v-model="daytimeMode" type="checkbox">
                        <span class="slider round"></span>
                    </label>
                </div>
                <div class="flex flex-row" style="margin-top: 15px; width: 100%; justify-content: space-around">
                    <div click.stop class="flex flex-col" style="height: 100%; align-items: baseline; align-content: center; justify-content: center; text-align: left; font-size: 20px; font-weight: 700; line-height: 1.1;  justify-content: center; align-content: center; align-items: center;">
                        Day start:
                        <select v-model="dayHourStart" @change="setDaytimeHourStart" style="color: #FFFFFF; background-color: #292929; border-radius: 5px; width: 100px; text-align: center; margin-top: 5px; font-size: 24px; padding: 2px 0;">
                            <option v-for="hour in hours" :value="hour" :label="hour + ':00'" :key="hour">{{hour}}</option>
                        </select> 
                    </div>
                    <div click.stop class="flex flex-col" style="height: 100%; align-items: baseline; align-content: center; justify-content: center; text-align: left; font-size: 20px; font-weight: 700; line-height: 1.1;  justify-content: center; align-content: center; align-items: center;">
                        Day end:
                        <select v-model="dayHourEnd" @change="setDaytimeHourEnd" style="color: #FFFFFF; background-color: #292929; border-radius: 5px; width: 100px; text-align: center; margin-top: 5px;  font-size: 24px; padding: 2px 0;">
                            <option v-for="hour in hours" :value="hour" :label="hour + ':00'" :key="hour">{{hour}}</option>
                        </select> 
                    </div>
                </div>
            </div>
            <div class="flex flex-row " style="width: 100%; border-top:1px solid; align-items: center; align-content: center; padding: 15px 30px; position: absolute; bottom: 53px; height: 53px;">
                <div class="flex flex-row" style="width: 100%; height: 100%; align-items: center; align-content: center; text-align: left; font-size: 20px; font-weight: 700; text-align: justify;">
                    Contact us:&nbsp;<a href="mailto:razvoj@media24.si" style="color: #409eff;">razvoj@media24.si</a>
                </div>
            </div>
            <a href="/policy" class="flex flex-row " style="width: 100%; border-top:1px solid; align-items: center; align-content: center; padding: 15px 30px; position: absolute; bottom: 0;">
                <div class="flex flex-col" style="width: 100%; height: 100%; align-items: baseline; align-content: center; justify-content: center; text-align: left; font-size: 20px; font-weight: 700; line-height: 1.1;">
                    Privacy policy
                </div>
            </a>
        </div>

        <div id="showGifts" class="showGifts flex flex-col" style="z-index: 5; position: fixed; max-width: 958px; top:0; height: 0px; width: 100%;">
            <i @click="showGiftsToggle()" class="fas fa-window-close" id="showGiftsClose" style="position: absolute; top: 7px; right: 7px; font-size: 28px;"></i>
        </div>

        <div v-if="stations" ref="showStationsRef" id="showStations" class="showStations" style="z-index: 5; position: fixed; max-width: 958px; bottom:0; height: 100%; width: 0px;">
            <div @click="showStationsToggle(index)" style="position: sticky; top: 0; right: 0; font-size: 28px;">
                <i class="fas fa-window-close" style="position: absolute; top: 6px; right: 7px;"></i>
            </div>
            <div v-for="(station, index) in stations" :key="index" @click="changeSlideTo(index)">
                <div class="flex flex-row stations-sidebar">
                    <div class="circle-image-small">
                        <img v-if="loadSmallStationImages || index <= loadSmallStationImagesIndex" :src="stations[index].image_url_small" alt="Station image" />
                    </div>
                    <div class="stations-right">
                        <div v-if="station" class="flex flex-col stations-text">
                            {{ station.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Station from './../models/Station'
import axios from 'axios'
import dayjs from 'dayjs'
import { Grid, Pagination, Navigation, Mousewheel, Lazy} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
    name: "portal",

    components: {
        Swiper,
        SwiperSlide,
    },

    data(){
        return {
            swiperModules: [Grid, Pagination, Navigation, Mousewheel, Lazy],
            showDates: [],
            stations: window.Stations,
            showDate: null,
            highlightedDates: [],
            disabledDates: [],
            currentStationIndex: 0,
            animationBoolean: true,
            currentStation: new Station(),
            firstLaunch: true,
            dayHourStart: '07',
            dayHourEnd: 21,
            hours: [...Array(24).keys()].map(m => String(m).padStart(2, '0')),
            loadSmallStationImages: false, // Page load optimizations
            loadSmallStationImagesIndex: 0, // Page load optimizations
            isPlaying: false,
            slidesPerView: 1.40,
            canvasHeight: 300,
            canvasWidth: 300,
            barColor: ['#ee4172'],
            darkmode: true,
            darkmodeBoolean: true,
            daytimeMode: false,
            is_iOS: false,
        }
    },

    created() {
        this.currentStation = this.stations[0]

        this.detectBrowser() // Disable animations on iOS, as they cause a so-far unexplained visual bug when scrolling through stations
        this.getStationsAPI()
        this.checkDaytimeMode()
        this.checkDarkMode()
        this.daytimeModeTimer()
        this.checkAnimation()
    },

    mounted() {
        /*...*/
        setInterval(this.getStationsAPI, 120000);
        
        setInterval(this.daytimeModeTimer, 60000); 

        let self = this;
        let player = document.getElementsByTagName('audio')[0];

        setTimeout( () => {
            self.loadSmallStationImagesIndex = 12
        }, 5000 );

        /* Retry on connection lost */
        player.onerror = function() {
            if (player.error.code == 2 || player.error.code == 4) {
                setTimeout( () => {
                    player.src = self.stations[self.currentStationIndex].audio_stream_url + "?timestamp=" + Date.now();
                    player.play();
                    console.log("connection lost")
                }, 5000 );
            }
        };
        
        player.onstalled = function() {
            if (self.is_iOS || !self.stations[self.currentStationIndex].is_stream){
                console.log("connection stall_iOS")
                return
            }
            
            player.src = self.stations[self.currentStationIndex].audio_stream_url + "?timestamp=" + Date.now();
            player.play();
            console.log("connection stalled")
        };

        player.addEventListener("pause",function() {
            self.isPlaying = false
        });

        player.addEventListener("play",function() {
            self.isPlaying = true
        });


        /* 
         * PWA ServiceWorker 
         */
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('/service-worker.js');
        }

        window.addEventListener("DOMContentLoaded", async event => {
            document.querySelector("#install").addEventListener("click", installApp);
        });

        let deferredPrompt;

        window.addEventListener('beforeinstallprompt', (e) => {
            // Prevents the default mini-infobar or install dialog from appearing on mobile
            e.preventDefault();
            // Save the event because you’ll need to trigger it later.
            deferredPrompt = e;
            // Show your customized install prompt for your PWA
            document.querySelector("#install").style.display="block";
        });

        async function installApp() {
            if (deferredPrompt) {
            deferredPrompt.prompt();
            // Find out whether the user confirmed the installation or not
            const { outcome } = await deferredPrompt.userChoice;
            // The deferredPrompt can only be used once.
            deferredPrompt = null;
            // We hide the install button
            document.querySelector("#install").style.display="none";
            }
        }

        /* Swiper: height responsive slides, need to do it in this way because setting height in CSS doesn't work well with SwiperJS */
        const resizeObserver = new ResizeObserver(entries => {
            let clientHeight = entries[0].target.clientHeight
            let clientWidth = entries[0].target.clientWidth
            let canvas = this.animationBoolean ? document.getElementsByTagName('canvas')[0] : null
            let canvasParent = document.getElementById("canvasParent")
            if (clientHeight <= 537)  { 
                this.slidesPerView = 1.4

                if (clientWidth >= 500 && this.animationBoolean) {
                    this.canvasHeight = 240
                    this.canvasWidth = 240
                    canvas.width = 240
                    canvas.height = 240
                    //canvasParent.style.paddingTop = "calc(14vh - 35px)"
                }
            }
            if (clientHeight >= 537)  { 
                this.slidesPerView = 1.6;

                if (this.animationBoolean) {
                    this.canvasHeight = 300;
                    this.canvasWidth = 300;
                    canvas.width = 300;
                    canvas.height = 300;
                    //canvasParent.style.paddingTop = "calc(14vh - 55px)";
                }
            }
            if (clientHeight >= 721)  { this.slidesPerView = 1.8 }
            if (clientHeight >= 821)  { this.slidesPerView = 2.1 }
            if (clientHeight >= 921)  { this.slidesPerView = 2.3 }
            if (clientHeight >= 1021) { this.slidesPerView = 2.5 }
            if (clientHeight >= 1121) { this.slidesPerView = 2.7 }
            if (clientHeight >= 1221) { this.slidesPerView = 2.9 }
        })
        resizeObserver.observe(document.body)

        this.setDraggableBar()
        this.setDraggableStations()
        this.setDraggableOptions()
        this.setDraggableGifts()
    },

    methods: {

        checkNetwork() {
            if (navigator.onLine) {
                console.log("online")
            }
            else {
                console.log("offline")
            }
        },
        seekBack(){
            let audio = document.getElementsByTagName('audio')[0]

            if(audio.currentTime - (audio.duration * 0.05) >= 0) {
                audio.currentTime = audio.currentTime  - (audio.duration * 0.05)
            }
        },

        seekForward(){
            let audio = document.getElementsByTagName('audio')[0]

            if(audio.currentTime + (audio.duration * 0.05) <= audio.duration) {
                audio.currentTime = audio.currentTime  + (audio.duration * 0.05)
            }
        },

        slideChange (data){
            if (this.currentStationIndex != data.realIndex){
                this.currentStationIndex = data.realIndex
                this.currentStation = this.stations[data.realIndex]

                let player =  document.getElementsByTagName('audio')[0]

                player.src = this.stations[data.realIndex].audio_stream_url + '?timestamp=' + Date.now()
                player.play()
            }

            this.showDates = []
            this.disabledDates = []
            this.highlightedDates = []
            if(!this.stations[data.realIndex].is_stream) {
                this.showDate = this.stations[data.realIndex].date
                this.stations[data.realIndex]['songs'][0].title = dayjs(this.showDate).format('YYYY-MM-DD')
                this.getShowDates(this.stations[data.realIndex].id)
            }
        },

        getShowDates(showGroupID){
            const options = {
                params: {
                    show_group_id: showGroupID
                }
            }
            axios.get('/publicapi/show_dates/', options)
                    .then(({ data }) => {
                        if (data) {
                            this.showDates = data.data
                            
                            for (let showDate of this.showDates) {
                                this.highlightedDates.push(showDate.date)
                            }

                            let startDate = new Date("08/01/2022");
                            let endDate = new Date(); // today

                            for (let day = startDate; day <= endDate; day.setDate(day.getDate() + 1)) {
                                let tempDay = dayjs(day).format('YYYY-MM-DD')

                                if (!this.highlightedDates.includes(tempDay)) {
                                    this.disabledDates.push(tempDay)
                                }
                            }
                        }
                    })
        },

        changeDate() {
            if(this.currentStation.is_stream){
                return
            }
            let index = this.showDates.findIndex(date => date.date ===  dayjs(this.showDate).format('YYYY-MM-DD'))
            if (index >= 0){
                this.stations[this.currentStationIndex]['songs'][0].title = dayjs(this.showDates[index].date).format('DD-MM-YYYY')
                this.stations[this.currentStationIndex].audio_stream_url = this.showDates[index].audio_stream_url
                this.currentStation[this.currentStationIndex] = this.stations[this.currentStationIndex]

                let player =  document.getElementsByTagName('audio')[0]

                player.src = this.showDates[index].audio_stream_url
                player.play()                
            }
        },

        getStationsAPI() {
            for (const [index, station] of this.stations.entries()) {
                if (station.is_stream && station.api_url) {
                    axios.get('https://api2.kme.si/v2/radio-live/' + station.api_url)
                    .then(({ data }) => {
                        if (data) {
                            if (data.data && data.data[0]) {
                                this.stations[index]['songs'] = new Station(data.data)
                            }
                            else {
                                this.stations[index]['songs'][0].api_down = true
                            }
                            
                            this.$nextTick(() => {
                                if (this.firstLaunch){
                                    if (data.data && data.data[0]) {
                                        this.currentStation['songs'] = data.data
                                    }
                                    else {
                                        this.stations[index]['songs'][0].api_down = true
                                    }

                                    this.firstLaunch = false

                                    let player = document.getElementsByTagName('audio')[0]
                                    player.src = this.stations[0].audio_stream_url + '?timestamp=' + Date.now()
                                    player.play()
                                }
                            })
                        }
                    })
                    .catch(({response}) => {
                        if(response){
                            this.stations[index]['songs'][0].api_down = true
                        }
                    })
                }
            }
        },

        togglePlay() {
            let player =  document.getElementsByTagName('audio')[0]
            if(player.paused) {
                player.play()
            }

            else {
                this.isPlaying = false // Need to set isPlaying here, because eventListener doesn't proc if player.src is changed
                player.src = player.src // Audio react animation doesn't go away unless we do this
                player.pause()
            }
        },

        checkDarkMode () {
            if (this.daytimeMode){
                this.darkmode = false
                this.darkmodeBoolean = false
                return
            }

            if (localStorage.getItem("darkmode") == 0) {
                this.darkmode = false
                this.darkmodeBoolean = false
                document.body.style.background = "#ECF1F8";
                return
            }

            this.darkmode = true
            this.darkmodeBoolean = true
            document.body.style.background = "#000000";            
        },

        toggleDarkMode () {  
            if (localStorage.getItem("darkmode") == 0) {
                this.darkmode = true
                this.darkmodeBoolean = true
                document.body.style.background = "#000000";
                localStorage.setItem("darkmode", "1")
            }

            else {
                this.darkmode = false
                this.darkmodeBoolean = false
                document.body.style.background = "#ECF1F8";
                localStorage.setItem("darkmode", "0")
            }
        },

        checkDaytimeMode () {
            if (localStorage.getItem("daytime_mode_start")) {
                this.dayHourStart = localStorage.getItem("daytime_mode_start")
            }

            if (localStorage.getItem("daytime_mode_end")) {
                this.dayHourEnd = localStorage.getItem("daytime_mode_end")
            }

            if (localStorage.getItem("daytime_mode") == 1) {
                this.daytimeMode = true
                return
            }

            this.daytimeMode = false         
        },

        toggleDaytimeMode () {  
            if (localStorage.getItem("daytime_mode") == 1) {
                this.daytimeMode = false
                localStorage.setItem("daytime_mode", "0")
                this.checkDarkMode()
            }

            else {
                this.daytimeMode = true
                this.darkmode = false
                localStorage.setItem("daytime_mode", "1")
                this.daytimeModeTimer()
            }
        },

        setDaytimeHourStart () {            
            if(this.dayHourStart){
                localStorage.setItem("daytime_mode_start", this.dayHourStart)
                this.daytimeModeTimer()
            }
        },

        setDaytimeHourEnd () {
            if(this.dayHourEnd){
                localStorage.setItem("daytime_mode_end", this.dayHourEnd)
                this.daytimeModeTimer()
            }
        },

        daytimeModeTimer () {
            if (!this.daytimeMode) {
                return
            }

            if ((this.dayHourStart < this.dayHourEnd && dayjs().hour() >= this.dayHourStart && dayjs().hour() < this.dayHourEnd) || 
                (this.dayHourStart > this.dayHourEnd && dayjs().hour() <= this.dayHourStart && dayjs().hour() < this.dayHourEnd)){
                if (this.darkmodeBoolean) {
                    document.body.style.background = "#ECF1F8";
                    this.darkmodeBoolean = false
                }
            }

            else {
                if (!this.darkmodeBoolean){
                    document.body.style.background = "#000000"
                    this.darkmodeBoolean = true
                }
            }
        },

        checkAnimation () {
            if (localStorage.getItem("animation") == 0) {
                this.animationBoolean = false
            }

            if (localStorage.getItem("animation") == 1) {
                this.animationBoolean = true
            }        
        },

        toggleAnimation () {
            let player =  document.getElementsByTagName('audio')[0]

            if (localStorage.getItem("animation") == 0) {
                this.animationBoolean = true
                localStorage.setItem("animation", "1")
            }

            else {
                this.animationBoolean = false
                localStorage.setItem("animation", "0")
            }
            
            location.reload()
        },

        setDraggableBar () {
            let showHistory = document.getElementById("showHistory")
            let bar = document.getElementById("bottomBarSong")
            showHistory.style.height = "0px" 
            let start_dragging = false
            let dragging = false;
            let initY = null;
            let previousPosition = -1;
            let currentPosition = 0;
            
            /* DESKTOP */
            bar.addEventListener("mousedown", (e) => {
                if (!this.currentStation.is_stream) return;

                dragging = false;
                start_dragging = true;
                showHistory.style.transition = "none"
                initY = showHistory.offsetHeight + e.clientY;
            })

            showHistory.addEventListener("mousedown", (e) => {
                if (showHistory.scrollTop != 0 || !this.currentStation.is_stream) return;

                dragging = false;
                start_dragging = true;
                showHistory.style.transition = "none"
                initY = showHistory.offsetHeight + e.clientY; 
            })

            window.addEventListener("mousemove", (e) => {
                if (!start_dragging || !this.currentStation.is_stream) return; 

                dragging = true
                showHistory.style.height = (initY - e.clientY) + "px"
                previousPosition = currentPosition;
                currentPosition = e.clientY;
            })

            window.addEventListener("mouseup", (e) => {
                if (!start_dragging) { return }

                start_dragging = false;
                showHistory.style.transition = "all 0.3s"

                if (!dragging || !this.currentStation.is_stream) return;
                
                dragging = false;
                
                if (previousPosition > e.clientY) {
                    showHistory.style.height = "100%";
                }

                else{
                    showHistory.style.height = "0px";
                }
            })




            /* MOBILE */
            bar.addEventListener("touchstart", (e) => {
                if (!this.currentStation.is_stream) return;

                dragging = false;
                start_dragging = true;
                showHistory.style.transition = "none"
                initY = showHistory.offsetHeight + e.touches[0].pageY; 
                previousPosition = e.touches[0].pageY;
            }, {passive: true})

            showHistory.addEventListener("touchstart", (e) => {
                if (showHistory.scrollTop != 0 || !this.currentStation.is_stream) return;

                dragging = false;
                start_dragging = true;
                showHistory.style.transition = "none"
                initY = showHistory.offsetHeight + e.touches[0].pageY; 
                previousPosition = e.touches[0].pageY;
            }, {passive: true})

            window.addEventListener("touchmove", (e) => {
                if (!start_dragging || !this.currentStation.is_stream) return; 

                dragging = true

                showHistory.style.height = (initY - e.touches[0].pageY) + "px"

                previousPosition = currentPosition;
                currentPosition = e.touches[0].pageY;
            })

            window.addEventListener("touchend", (e) => { 
                start_dragging = false;

                if (!dragging || !this.currentStation.is_stream) return;
                
                dragging = false;

                showHistory.style.transition = "all 0.3s"

                if (previousPosition > e.changedTouches[0].pageY) {
                    showHistory.style.height = "100%";
                }

                else{
                    showHistory.style.height = "0px";
                }
            })
        },

        setDraggableStations () {
            let showStations = document.getElementById("showStations")
            let bar = document.getElementById("showStationsToggle")
            showStations.style.width = "0px" 
            let start_dragging = false
            let dragging = false;
            let initX = null;
            let startPosition = 0;
            let previousPosition = -1;
            let currentPosition = 0;
            
            /* DESKTOP */
            showStations.addEventListener("mousedown", (e) => {
                dragging = false;
                start_dragging = true;
                showStations.style.transition = "none"
                initX = Math.abs(showStations.offsetWidth - e.clientX);
                startPosition = e.clientX;
            })

            window.addEventListener("mousemove", (e) => {
                if (!start_dragging) return; 

                dragging = true
                showStations.style.width = (initX + e.clientX) + "px"
                previousPosition = currentPosition;
                currentPosition = e.clientX;
            })

            window.addEventListener("mouseup", (e) => {
                if (!start_dragging) { return }

                start_dragging = false;
                showStations.style.transition = "all 0.3s"

                if (!dragging) return;
                
                dragging = false;
                if (startPosition <= e.clientX + (showStations.offsetWidth * 0.2)) {
                    showStations.style.width = "100%";
                }

                else{
                    showStations.style.width = "0px";
                }
            })




            /* MOBILE */
            showStations.addEventListener("touchstart", (e) => {
                if (showStations.scrollLeft != 0) return;

                dragging = false;
                start_dragging = true;
                showStations.style.transition = "none"
                initX = Math.abs(showStations.offsetWidth - e.touches[0].pageX);
                startPosition = e.touches[0].pageX;
                previousPosition = e.touches[0].pageX;
            }, {passive: true})

            window.addEventListener("touchmove", (e) => {
                if (!start_dragging) return; 

                dragging = true

                showStations.style.width = (initX + e.touches[0].pageX) + "px"

                previousPosition = currentPosition;
                currentPosition = e.touches[0].pageX;
            })

            window.addEventListener("touchend", (e) => { 
                start_dragging = false;

                if (!dragging) return;
                
                dragging = false;

                showStations.style.transition = "all 0.3s"

                if (startPosition < e.changedTouches[0].pageX + (showStations.offsetWidth * 0.2)) {
                    showStations.style.width = "100%";
                }

                else{
                    showStations.style.width = "0px";
                }
            })
        },

        setDraggableOptions () {
            let showSettings = document.getElementById("showSettings")
            let bar = document.getElementById("showSettingsToggle")
            showSettings.style.height = "0px" 
            let start_dragging = false
            let dragging = false;
            let initY = null;
            let previousPosition = -1;
            let startPosition = 0;
            let currentPosition = 0;
            
            /* DESKTOP */
            showSettings.addEventListener("mousedown", (e) => {
                if (showSettings.scrollTop != 0) return;

                dragging = false;
                start_dragging = true;
                showSettings.style.transition = "none"
                initY = Math.abs(showSettings.offsetHeight - e.clientY);
                startPosition = e.clientY;
            })

            window.addEventListener("mousemove", (e) => {
                if (!start_dragging) return; 

                dragging = true
                showSettings.style.height = (initY + e.clientY) + "px"
                previousPosition = currentPosition;
                currentPosition = e.clientY;
            })

            window.addEventListener("mouseup", (e) => {
                if (!start_dragging) { return }

                start_dragging = false;
                showSettings.style.transition = "all 0.3s"

                if (!dragging) return;
                
                dragging = false;
                
                if (startPosition < e.clientY + (showSettings.offsetHeight * 0.1)) {
                    showSettings.style.height = "100%";
                }

                else{
                    showSettings.style.height = "0px";
                }
            })




            /* MOBILE */
            showSettings.addEventListener("touchstart", (e) => {
                if (showSettings.scrollTop != 0) return;

                dragging = false;
                start_dragging = true;
                showSettings.style.transition = "none"
                initY = Math.abs(showSettings.offsetHeight - e.touches[0].pageY);
                previousPosition = e.touches[0].pageY;
                startPosition = e.touches[0].pageY;
            }, {passive: true})

            window.addEventListener("touchmove", (e) => {
                if (!start_dragging) return; 

                dragging = true

                showSettings.style.height = (initY + e.touches[0].pageY) + "px"

                previousPosition = currentPosition;
                currentPosition = e.touches[0].pageY;
            })

            window.addEventListener("touchend", (e) => { 
                start_dragging = false;

                if (!dragging) return;
                
                dragging = false;

                showSettings.style.transition = "all 0.3s"

                if (startPosition < e.changedTouches[0].pageY + (showSettings.offsetHeight * 0.1)) {
                    showSettings.style.height = "100%";
                }

                else{
                    showSettings.style.height = "0px";
                }
            })
        },

        setDraggableGifts () {
            let showGifts = document.getElementById("showGifts")
            let bar = document.getElementById("showGiftsToggle")
            showGifts.style.height = "0px" 
            let start_dragging = false
            let dragging = false;
            let initY = null;
            let previousPosition = -1;
            let currentPosition = 0;
            
            /* DESKTOP */
            showGifts.addEventListener("mousedown", (e) => {
                if (showGifts.scrollTop != 0) return;

                dragging = false;
                start_dragging = true;
                showGifts.style.transition = "none"
                initY = Math.abs(showGifts.offsetHeight - e.clientY);
            })

            window.addEventListener("mousemove", (e) => {
                if (!start_dragging) return; 

                dragging = true
                showGifts.style.height = (initY + e.clientY) + "px"
                previousPosition = currentPosition;
                currentPosition = e.clientY;
            })

            window.addEventListener("mouseup", (e) => {
                if (!start_dragging) { return }

                start_dragging = false;
                showGifts.style.transition = "all 0.3s"

                if (!dragging) return;
                
                dragging = false;
                
                if (previousPosition < e.clientY) {
                    showGifts.style.height = "100%";
                }

                else{
                    showGifts.style.height = "0px";
                }
            })




            /* MOBILE */
            showGifts.addEventListener("touchstart", (e) => {
                if (showGifts.scrollTop != 0) return;

                dragging = false;
                start_dragging = true;
                showGifts.style.transition = "none"
                initY = Math.abs(showGifts.offsetHeight - e.touches[0].pageY);
                previousPosition = e.touches[0].pageY;
            }, {passive: true})

            window.addEventListener("touchmove", (e) => {
                if (!start_dragging) return; 

                dragging = true

                showGifts.style.height = (initY + e.touches[0].pageY) + "px"

                previousPosition = currentPosition;
                currentPosition = e.touches[0].pageY;
            })

            window.addEventListener("touchend", (e) => { 
                start_dragging = false;

                if (!dragging) return;
                
                dragging = false;

                showGifts.style.transition = "all 0.3s"

                if (previousPosition < e.changedTouches[0].pageY) {
                    showGifts.style.height = "100%";
                }

                else{
                    showGifts.style.height = "0px";
                }
            })
        },        

        slideNext () {
            document.getElementById("swiper").swiper.slideNext()
        },

        slidePrev () {
            document.getElementById("swiper").swiper.slidePrev()
        },

        changeSlideTo (index) {
            document.getElementById("swiper").swiper.slideTo(index)

            let showHistory = document.getElementById("showStations")
            showHistory.style.width = "0px"
        },

        showHistoryToggle() {
            let showHistory = document.getElementById("showHistory")
            showHistory.style.transition = "all 0.3s"

            if (showHistory.style.height == "0px"){
                showHistory.style.height = "100%"
            }

            else {
                showHistory.style.height = "0px"
            }
        },

        showSettingsToggle() {
            let showSettings = document.getElementById("showSettings")
            showSettings.style.transition = "all 0.3s"

            if (showSettings.style.height == "0px"){
                showSettings.style.height = "100%"
            }

            else {
                showSettings.style.height = "0px"
            }
        },

        showGiftsToggle() {
            let showGifts = document.getElementById("showGifts")
            showGifts.style.transition = "all 0.3s"

            if (showGifts.style.height == "0px"){
                showGifts.style.height = "100%"
            }

            else {
                showGifts.style.height = "0px"
            }
        },

        showStationsToggle() {
            /* First loadtime optimizations */
            if (!this.loadSmallStationImages) {
                this.loadSmallStationImages = true
            }

            let showStations = document.getElementById("showStations")
            showStations.style.transition = "all 0.3s"

            if (showStations.style.width == "0px"){
                showStations.style.width = "100%"
            }

            else {
                showStations.style.width = "0px"
            }
        },

        detectBrowser() {
            const browserDetection = require("@braintree/browser-detection");
            if(browserDetection.isIos() || browserDetection.isIosFirefox() || browserDetection.isIosGoogleSearchApp() || browserDetection.isIosSafari() || browserDetection.isIosWebview() || browserDetection.isIosUIWebview() || browserDetection.isIosUIWebview()) {
                this.animationBoolean = false
                this.is_iOS = true
                
                if(localStorage.getItem("animation") != 0 && localStorage.getItem("animation") != 1){
                    localStorage.setItem("animation", "0")
                }
            }
        }
    },
}
</script>